import Header from "@/components/Header";
import Footer from "@/components/Footer";
import NewsTicker from "@/components/NewsTicker";
import AdSlot from "@/components/AdSlot";

export default function Layout({ children, showTicker = true }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      {showTicker && <NewsTicker />}
      <main className="flex-1">{children}</main>
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <AdSlot placement="footer" className="mb-10" />
      </div>
      <Footer />
    </div>
  );
}
